import { render, staticRenderFns } from "./OnboardingMeta.vue?vue&type=template&id=ffe91290&scoped=true"
import script from "./OnboardingMeta.vue?vue&type=script&lang=js"
export * from "./OnboardingMeta.vue?vue&type=script&lang=js"
import style0 from "./OnboardingMeta.vue?vue&type=style&index=0&id=ffe91290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe91290",
  null
  
)

export default component.exports